import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestTmppaysGetRes } from "./abst/DtoRequestTmppaysGetRes";

export class DtoRequestTmppaysGetResImple extends DtoRequestTmppaysGetRes {
  public request = new EntityRequest();
  
  public pager = new DtoApiPager();
}
